unit UCommentForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.Buttons,
  UEssentialHelper, UWebSpeechRec;

type
  TCommentForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlButtons: TPanel;
    btnStore: TBitBtn;
    pnlComment: TPanel;
    memComment: TMemo;
    btnMicOn: TBitBtn;
    btnMicOff: TBitBtn;
    chkPunctationMark: TCheckBox;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure btnStoreClick(Sender: TObject);
    procedure btnDeleteClick(Sender: TObject);
    procedure SpeechRecNoResultMatch(Sender: TObject; Phrases: TStrings);
    procedure btnMicOnClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure SpeechRecCommands0Command(Sender: TObject; Parameters: TStrings);
    procedure SpeechRecCommands1Command(Sender: TObject; Parameters: TStrings);
    procedure SpeechRecCommands2Command(Sender: TObject; Parameters: TStrings);
    procedure chkPunctationMarkClick(Sender: TObject);
    procedure SpeechRecCommands3Command(Sender: TObject; Parameters: TStrings);
    procedure btnMicOffClick(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMainConfig: TMainConfig;
    FFakNr: string;
    FOnTakeComment: TSnapshotEvent;
    FFilename: string;
    procedure DoButtonDeleteClick;
    procedure DoTakeComment(Filename: string);
    procedure HandlePropertyChanged(Sender: TObject; PropertyName: string);
    procedure HandleSpeechRecNoResultMatch(Sender: TObject; Phrases: TStrings);
    procedure HandleSpeechRecCommand(Sender: TObject;
      SpeechRecCommand: TSpeechRecCommand; Parameters: TStrings);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetFakNr(const Value: string);
    procedure SetOnTakeComment(const Value: TSnapshotEvent);
    procedure SetFilename(const Value: string);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property FakNr: string read FFakNr write SetFakNr;
    property OnTakeComment: TSnapshotEvent read FOnTakeComment
      write SetOnTakeComment;
    property Filename: string read FFilename write SetFilename;
  protected procedure LoadDFMValues; override; end;

var
  CommentForm: TCommentForm;

implementation

uses
  WEBLib.LocalFiles;

{$R *.dfm}
{ TCommentForm }

procedure TCommentForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TCommentForm.btnDeleteClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.DoButtonDeleteClick;
end;

procedure TCommentForm.btnMicOffClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.MainConfig.SpeechRec.Stopp;
end;

procedure TCommentForm.btnMicOnClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.MainConfig.SpeechRec.Start;
end;

procedure TCommentForm.btnStoreClick(Sender: TObject);
var
  tFile: TTextFile;
  procedure HandleFileSave(Sender: TObject);
  begin
    if Sender is TTextFile then
      Self.DoTakeComment((Sender as TTextFile).Filename);
    Self.Close;
  end;

begin
  Self.MainConfig.TimerReset;
  if Self.Filename = '' then
    Self.Filename := FormatDateTime('yyyymmdd_hhnnss', now) + '.txt';
  tFile := TTextFile.Create(nil);
  tFile.OnFileSave := HandleFileSave;
  tFile.Text := memComment.Lines.Text;
  tFile.SaveAsFile(Self.FakNr + '\Comments', Self.Filename);
end;

procedure TCommentForm.chkPunctationMarkClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
end;

procedure TCommentForm.DoButtonDeleteClick;
begin
end;

procedure TCommentForm.DoTakeComment(Filename: string);
begin
  if Assigned(Self.OnTakeComment) then
    Self.OnTakeComment(Self, Filename, akComment);
end;

procedure TCommentForm.HandlePropertyChanged(Sender: TObject;
  PropertyName: string);
begin
  if PropertyName = 'Active' then
  begin
    btnMicOn.Visible := not Self.MainConfig.SpeechRec.Active;
    btnMicOff.Visible := Self.MainConfig.SpeechRec.Active;
  end;
end;

procedure TCommentForm.HandleSpeechRecCommand(Sender: TObject;
  SpeechRecCommand: TSpeechRecCommand; Parameters: TStrings);
var
  s: string;
  i: Integer;
begin
  case SpeechRecCommand of
    srcAll:
      memComment.Clear;
    srcLast:
      begin
        if memComment.Lines.Count > 0 then
          memComment.Lines.Delete(memComment.Lines.Count - 1);
      end;
    srcNumber:
      begin
        s := Parameters[0];
        if TryStrToInt(s, i) then
        begin
          Dec(i);
          if (0 <= i) and (i < memComment.Lines.Count) then
            memComment.Lines.Delete(i);
        end;
      end;
  end;
end;

procedure TCommentForm.HandleSpeechRecNoResultMatch(Sender: TObject;
  Phrases: TStrings);
var
  s, t: string;
begin
  s := Phrases[0];
  s := Trim(s);
  if s <> '' then
  begin
    t := s[1];
    t := UpperCase(t);
    Delete(s, 1, 1);
    s := t + s;
    if chkPunctationMark.Checked then
    begin
      s := Trim(s);
      t := Copy(s, Length(s) - 5, 6);
      t := LowerCase(t);
      if t = ' punkt' then
      begin
        Delete(s, Length(s) - 5, 6);
        s := s + '.';
      end;
      s := StringReplace(s, ' Komma', ',', [rfReplaceAll]);
      s := StringReplace(s, 'Strich', '-', [rfReplaceAll]);
      s := StringReplace(s, ' Fragezeichen', '?', [rfReplaceAll]);
      s := StringReplace(s, ' Ausrufezeichen', '!', [rfReplaceAll]);
      s := StringReplace(s, ' Doppelpunkt', ':', [rfReplaceAll]);
      s := StringReplace(s, ' Semikolon', ';', [rfReplaceAll]);
      if s[Length(s)] <> '.' then
        s := s + '.';
    end;
    memComment.Lines.Add(s);
  end;
end;

procedure TCommentForm.SetFakNr(const Value: string);
begin
  FFakNr := Value;
end;

procedure TCommentForm.SetFilename(const Value: string);
var
  tFile: TTextFile;
  procedure HandleFileOpen(Sender: TObject);
  begin
    if Sender is TTextFile then
      memComment.Lines.Text := (Sender as TTextFile).Text;
  end;

begin
  FFilename := Value;
  if Self.Filename <> '' then
  begin
    tFile := TTextFile.Create(nil);
    tFile.OnFileOpen := HandleFileOpen;
    tFile.OpenFile(Self.FakNr + '\Comments', Self.Filename);
  end
  else
    memComment.Clear;
end;

procedure TCommentForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
  Self.MainConfig.SpeechRec.OnSpeechRecCommand := Self.HandleSpeechRecCommand;
  Self.MainConfig.SpeechRec.OnSpeechRecNoResultMatch :=
    Self.HandleSpeechRecNoResultMatch;
  Self.MainConfig.SpeechRec.OnPropertyChanged := Self.HandlePropertyChanged;
  Self.HandlePropertyChanged(Self,'Active');
end;

procedure TCommentForm.SetOnTakeComment(const Value: TSnapshotEvent);
begin
  FOnTakeComment := Value;
end;

procedure TCommentForm.SpeechRecCommands0Command(Sender: TObject;
  Parameters: TStrings);
begin
  if memComment.Lines.Count > 0 then
    memComment.Lines.Delete(memComment.Lines.Count - 1);
end;

procedure TCommentForm.SpeechRecCommands1Command(Sender: TObject;
  Parameters: TStrings);
var
  s: string;
  i: Integer;
begin
  s := Parameters[0];
  if TryStrToInt(s, i) then
  begin
    Dec(i);
    if i < 0 then
      i := 0;
    memComment.Lines.Delete(i);
  end;
end;

procedure TCommentForm.SpeechRecCommands2Command(Sender: TObject;
  Parameters: TStrings);
begin
  memComment.Clear;
end;

procedure TCommentForm.SpeechRecCommands3Command(Sender: TObject;
  Parameters: TStrings);
begin
  if memComment.Lines.Count > 0 then
    memComment.Lines.Delete(0);
end;

procedure TCommentForm.SpeechRecNoResultMatch(Sender: TObject;
  Phrases: TStrings);
var
  s, t: string;
begin
  s := Phrases[0];
  s := Trim(s);
  if s <> '' then
  begin
    t := s[1];
    t := UpperCase(t);
    Delete(s, 1, 1);
    s := t + s;
    if chkPunctationMark.Checked then
    begin
      s := Trim(s);
      t := Copy(s, Length(s) - 5, 6);
      t := LowerCase(t);
      if t = ' punkt' then
      begin
        Delete(s, Length(s) - 5, 6);
        s := s + '.';
      end;
      s := StringReplace(s, ' Komma', ',', [rfReplaceAll]);
      s := StringReplace(s, 'Strich', '-', [rfReplaceAll]);
      s := StringReplace(s, ' Fragezeichen', '?', [rfReplaceAll]);
      s := StringReplace(s, ' Ausrufezeichen', '!', [rfReplaceAll]);
      s := StringReplace(s, ' Doppelpunkt', ':', [rfReplaceAll]);
      s := StringReplace(s, ' Semikolon', ';', [rfReplaceAll]);
      if s[Length(s)] <> '.' then
        s := s + '.';
    end;
    memComment.Lines.Add(s);
  end;
end;

procedure TCommentForm.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  if Self.MainConfig.SpeechRec.Active then
    Self.MainConfig.SpeechRec.Stopp;
  Self.MainConfig.SpeechRec.OnSpeechRecNoResultMatch := nil;
  Self.MainConfig.SpeechRec.OnSpeechRecCommand := nil;
  Self.MainConfig.SpeechRec.OnpropertyChanged := nil;
end;

procedure TCommentForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TCommentForm.WebFormResize(Sender: TObject);
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Notizen';
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Notizen';
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  btnStore.Left := pnlButtons.ClientWidth - btnStore.Width - 6;
  btnMicOff.Left := btnMicOn.Left;
  chkPunctationMark.Left := btnMicOn.Left + btnMicOn.Width + 8;
end;

procedure TCommentForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlButtons := TPanel.Create(Self);
  btnStore := TBitBtn.Create(Self);
  btnMicOn := TBitBtn.Create(Self);
  btnMicOff := TBitBtn.Create(Self);
  chkPunctationMark := TCheckBox.Create(Self);
  pnlComment := TPanel.Create(Self);
  memComment := TMemo.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlButtons.BeforeLoadDFMValues;
  btnStore.BeforeLoadDFMValues;
  btnMicOn.BeforeLoadDFMValues;
  btnMicOff.BeforeLoadDFMValues;
  chkPunctationMark.BeforeLoadDFMValues;
  pnlComment.BeforeLoadDFMValues;
  memComment.BeforeLoadDFMValues;
  try
    Name := 'CommentForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UCommentForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Notizen';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UCommentForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlButtons.SetParentComponent(Self);
    pnlButtons.Name := 'pnlButtons';
    pnlButtons.Left := 0;
    pnlButtons.Top := 408;
    pnlButtons.Width := 640;
    pnlButtons.Height := 48;
    pnlButtons.Align := alBottom;
    pnlButtons.Caption := 'pnlButtons';
    pnlButtons.ChildOrder := 2;
    pnlButtons.ShowCaption := False;
    btnStore.SetParentComponent(pnlButtons);
    btnStore.Name := 'btnStore';
    btnStore.Left := 541;
    btnStore.Top := 4;
    btnStore.Width := 40;
    btnStore.Height := 40;
    btnStore.Hint := 'Text '#252'bernehmen';
    btnStore.Color := clNone;
    btnStore.Glyph.LoadFromFile('UCommentForm.pnlButtons.btnStore.Glyph.png');
    btnStore.GlyphSize := 32;
    btnStore.HeightPercent := 100.000000000000000000;
    btnStore.ShowHint := True;
    btnStore.WidthPercent := 100.000000000000000000;
    SetEvent(btnStore, Self, 'OnClick', 'btnStoreClick');
    btnMicOn.SetParentComponent(pnlButtons);
    btnMicOn.Name := 'btnMicOn';
    btnMicOn.Left := 4;
    btnMicOn.Top := 4;
    btnMicOn.Width := 40;
    btnMicOn.Height := 40;
    btnMicOn.Hint := 'Mikrofon an';
    btnMicOn.Color := clNone;
    btnMicOn.Glyph.LoadFromFile('UCommentForm.pnlButtons.btnMicOn.Glyph.png');
    btnMicOn.GlyphSize := 32;
    btnMicOn.HeightPercent := 100.000000000000000000;
    btnMicOn.ShowHint := True;
    btnMicOn.WidthPercent := 100.000000000000000000;
    SetEvent(btnMicOn, Self, 'OnClick', 'btnMicOnClick');
    btnMicOff.SetParentComponent(pnlButtons);
    btnMicOff.Name := 'btnMicOff';
    btnMicOff.Left := 62;
    btnMicOff.Top := 4;
    btnMicOff.Width := 40;
    btnMicOff.Height := 40;
    btnMicOff.Hint := 'Mikrofon aus';
    btnMicOff.Color := clNone;
    btnMicOff.Glyph.LoadFromFile('UCommentForm.pnlButtons.btnMicOff.Glyph.png');
    btnMicOff.GlyphSize := 32;
    btnMicOff.HeightPercent := 100.000000000000000000;
    btnMicOff.ShowHint := True;
    btnMicOff.WidthPercent := 100.000000000000000000;
    SetEvent(btnMicOff, Self, 'OnClick', 'btnMicOffClick');
    chkPunctationMark.SetParentComponent(pnlButtons);
    chkPunctationMark.Name := 'chkPunctationMark';
    chkPunctationMark.Left := 216;
    chkPunctationMark.Top := 13;
    chkPunctationMark.Width := 153;
    chkPunctationMark.Height := 22;
    chkPunctationMark.Caption := 'Satzzeichenerkennung';
    chkPunctationMark.Checked := True;
    chkPunctationMark.ChildOrder := 3;
    chkPunctationMark.HeightPercent := 100.000000000000000000;
    chkPunctationMark.State := cbChecked;
    chkPunctationMark.WidthPercent := 100.000000000000000000;
    SetEvent(chkPunctationMark, Self, 'OnClick', 'chkPunctationMarkClick');
    pnlComment.SetParentComponent(Self);
    pnlComment.Name := 'pnlComment';
    pnlComment.Left := 0;
    pnlComment.Top := 64;
    pnlComment.Width := 640;
    pnlComment.Height := 344;
    pnlComment.Align := alClient;
    pnlComment.Caption := 'pnlComment';
    pnlComment.ChildOrder := 3;
    pnlComment.ShowCaption := False;
    memComment.SetParentComponent(pnlComment);
    memComment.Name := 'memComment';
    memComment.Left := 0;
    memComment.Top := 0;
    memComment.Width := 640;
    memComment.Height := 344;
    memComment.Align := alClient;
    memComment.Font.Charset := DEFAULT_CHARSET;
    memComment.Font.Color := clWindowText;
    memComment.Font.Height := -16;
    memComment.Font.Name := 'Segoe UI';
    memComment.Font.Style := [];
    memComment.HeightPercent := 100.000000000000000000;
    memComment.Lines.BeginUpdate;
    try
      memComment.Lines.Clear;
      memComment.Lines.Add('memComment');
    finally
      memComment.Lines.EndUpdate;
    end;
    memComment.ParentFont := False;
    memComment.SelLength := 0;
    memComment.SelStart := 0;
    memComment.WidthPercent := 100.000000000000000000;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlButtons.AfterLoadDFMValues;
    btnStore.AfterLoadDFMValues;
    btnMicOn.AfterLoadDFMValues;
    btnMicOff.AfterLoadDFMValues;
    chkPunctationMark.AfterLoadDFMValues;
    pnlComment.AfterLoadDFMValues;
    memComment.AfterLoadDFMValues;
  end;
end;

end.
